import React, { Component } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { compose } from 'redux'
import { TOGGLE_SHARE_SUCCESS } from '../../actionTypes'
import { toggleDropBox } from '../../actions'
import {CopyToClipboard} from 'react-copy-to-clipboard';



class Share extends Component {

    state = {
        copied: false,
    };


    render() {
        const { dropBox, toggleDropBox } = this.props
        const path = window.location.href
        const dropClass = classNames({
            'pop-full-box': true,
            'active': dropBox.share
        });

        return (
            <div className={dropClass}>
                <div className="pop-full-box__bg" onClick={() => toggleDropBox(TOGGLE_SHARE_SUCCESS)}></div>

                <div className="pop-full-box__wrap">
                    <div className="pop-block__header">
                        <div className="pop-block__head-wrap">
                            <div className="pop-block__head-icon">
                                <i className="icon-share"></i>
                            </div>
                            <div className="pop-block__head-hint">
                                Share
                            </div>
                        </div>
                        <div className="pop-full-box__close" onClick={() => toggleDropBox(TOGGLE_SHARE_SUCCESS)}>
                            <i className="icon-close"></i>
                        </div>
                    </div>
                    <div className="pop-block__content">
                        <div className="pop-block__label">Project Link</div>
                        <div className="pop-block__field-wrap">

                            <CopyToClipboard text={path} onCopy={() => this.setState({copied: true})}>
                                <div>
                                    <input onChange={() => {}} type="text" className="pop-block__field" value={path} />

                                    <div className="pop-block__field-icon-wrap">
                                        <i className="icon-copy"></i>
                                    </div>
                                </div>

                            </CopyToClipboard>

                        </div>
                        {this.state.copied ? <div className="copied">Copied.</div> : null}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    dropBox: state.dropBox,
    ownProps
})

const mapDispatchToProps = {
    toggleDropBox,
}

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(Share)


// WEBPACK FOOTER //
// ./src/containers/drop/Share.js